import React from "react";
import {
    Menu,
    ActivityIndicator,
    NavBar,
    Icon,
    ListView,
    Badge,
    Toast,
    Modal,
    Button,
    Picker,
    List,
} from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";
import arrayTreeFilter from "array-tree-filter";

import { wxfx } from "../../utils/wxfx.js";

// import {listData} from '../data/data.js';
import { carData } from "../data/carData.js";
import cityData from "../data/cityData.js";
import "./index.less";
import mc from "../image/1.png";

let listData = Object.keys(carData).map((key) => carData[key]);
const province = [];
// console.log(cityData)

function MyBody(props) {
    return (
        <div
            className="am-list-body my-body"
            style={{ backgroundColor: "#fff" }}
        >
            {props.children}
        </div>
    );
}

let skipCount = 0;
const pageSize = 15;
let count = 0;
function genData(data = [], pIndex = 0) {
    const dataBlob = {};
    for (let i = 0; i < data.length; i++) {
        const ii = pIndex * pageSize + i;
        dataBlob[`${ii}`] = `row - ${ii}`;
    }
    return dataBlob;
}

function dataHandle(data, ops1, ops2) {
    if (!data) {
        return;
    }
    if (ops1) {
        var a = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].type == ops1) {
                a.push(data[i]);
            }
        }
        data = a;
    }
    // if(ops2){
    //     var a = [];
    //     for(var i=0;i<data.length;i++){
    //         if(data[i].PP == ops2){
    //             a.push(data[i]);
    //         }
    //     }
    //     data = a;
    // }
    return data;
}

class MarketingOnlineIndex extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            initData: [],
            selectCX: "",
            selectPP: "",
            selectData: [
                [
                    {
                        value: "浙江",
                        label: "浙江",
                    },
                    {
                        value: "安徽",
                        label: "安徽",
                    },
                    {
                        value: "四川",
                        label: "四川",
                    },
                    {
                        value: "陕西",
                        label: "陕西",
                    },
                    {
                        value: "河南",
                        label: "河南",
                    },
                    {
                        value: "湖南",
                        label: "湖南",
                    },
                    {
                        value: "湖北",
                        label: "湖北",
                    },
                    {
                        value: "广东",
                        label: "广东",
                    },
                    {
                        value: "江西",
                        label: "江西",
                    },
                    {
                        value: "云南",
                        label: "云南",
                    },
                    {
                        value: "贵州",
                        label: "贵州",
                    },
                    {
                        value: "福建",
                        label: "福建",
                    },
                    {
                        value: "重庆",
                        label: "重庆",
                    },
                    {
                        value: "江苏",
                        label: "江苏",
                    },
                    {
                        value: "北京",
                        label: "北京",
                    },
                    {
                        value: "河北",
                        label: "河北",
                    },
                    {
                        value: "天津",
                        label: "天津",
                    },
                    {
                        value: "山东",
                        label: "山东",
                    },
                    {
                        value: "山西",
                        label: "山西",
                    },
                    {
                        value: "上海",
                        label: "上海",
                    },
                    {
                        value: "海南",
                        label: "海南",
                    },
                    {
                        value: "辽宁",
                        label: "辽宁",
                    },
                    {
                        value: "广西",
                        label: "广西",
                    },
                    {
                        value: "沈阳",
                        label: "沈阳",
                    },
                    {
                        value: "甘肃",
                        label: "甘肃",
                    },
                    {
                        value: "新疆",
                        label: "新疆",
                    },
                ],
                [
                    {
                        value: "",
                        label: "所有车型",
                    },
                    {
                        value: "微面",
                        label: "微面",
                    },
                    {
                        value: "轻客",
                        label: "轻客",
                    },
                    {
                        value: "微卡",
                        label: "微卡",
                    },
                    {
                        value: "轻卡",
                        label: "轻卡",
                    },
                ],
                // [
                //     {
                //         value: '',
                //         label: '所有品牌',
                //     },
                //     {
                //         value: '吉利',
                //         label: '吉利',
                //     },
                //     {
                //         value: '东风',
                //         label: '东风',
                //     },
                //     {
                //         value: '江淮',
                //         label: '江淮',
                //     },
                //     {
                //         value: '开瑞',
                //         label: '开瑞',
                //     }
                // ],
            ],
            selectType: 0,
            show: false,
            selectCity: "",
            dataList: [],
            dataSource: new ListView.DataSource({
                rowHasChanged: (row1, row2) => row1 !== row2,
            }),
            carTyoeBtn: false,
            successType: false,
            unfold: false,
            userName: "",
            carTypes: "",
            phoneNumber: "",
            pickerValue: [],
            visible: false,
            urlOps: {},
        };

        this.getCity();
    }
    componentDidMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] = obj1[i].split("=")[1];
            }
            this.setState({
                urlOps: ops,
            });
        }

        var url = `${window.location.origin}/payment/#/MarketingOnlineIndex`;
        if (ops.source) {
            url = url + "&source=" + ops.source;
        }
        var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
        if (ua.indexOf("micromessenger") > -1) {
            //在微信中打开
            wxfx({
                title: "福利来袭，租车有礼",
                imgUrl: "https://image.tf56.com/dfs/group1/M00/7C/2E/CiFCK2DIPFiAd_X9AC_9mR5moC0165.png",
                desc: "送货市区进不去？试试新能源吧！",
                url: url,
            });
        }
    }
    getCity() {
        const _this = this;

        setTimeout(() => {
            _this.getLocation();
        }, 200);
    }

    getLocation() {
        const { initData, selectData } = this.state;
        const _this = this;
        let localStorageCity = localStorage.getItem("province");
        let localStorageCX = localStorage.getItem("selectCX");
        // let localStoragePP = localStorage.getItem("selectPP");
        if (localStorageCity && localStorageCity !== "其他") {
            var cityName = localStorageCity;
            this.setState(
                {
                    selectCity: cityName,
                    selectCX: localStorageCX,
                    // selectPP: localStoragePP,
                    show: false,
                    selectType: 0,
                },
                () => {
                    this.onChange([cityName]);
                }
            );
            return;
        }
        //     if(!type){
        localStorage.removeItem("province");
        localStorage.removeItem("selectCX");
        // localStorage.removeItem("selectPP");
        _this.setState({
            selectCity: "",
            show: true,
            selectType: 0,
            initData: selectData[0],
            dataList: [],
        });
        //     }
        // });
    }

    onChange = (value) => {
        var data = [];
        var ops = {};
        if (this.state.selectType === 0) {
            if (this.state.selectCity !== "其他") {
                // data = dataHandle(listData[value[0]], this.state.selectCX, this.state.selectPP);
                data = dataHandle(
                    listData,
                    this.state.selectCX,
                    this.state.selectPP
                );
                localStorage.setItem("province", value[0]);
                ops = {
                    selectCity: value[0],
                };
            } else {
                // data = dataHandle(listData[value[0]], '', '');
                data = dataHandle(listData, "", "");
                localStorage.setItem("province", value[0]);
                localStorage.setItem("selectCX", "");
                // localStorage.setItem("selectPP",'');
                ops = {
                    selectCity: value[0],
                    selectCX: "",
                    selectPP: "",
                };
            }
        }
        if (this.state.selectType === 1) {
            // data = dataHandle(listData[this.state.selectCity], value[0], this.state.selectPP);
            data = dataHandle(listData, value[0], this.state.selectPP);
            localStorage.setItem("selectCX", value[0]);
            ops = {
                selectCX: value[0],
            };
        }
        // if(this.state.selectType === 2){
        //     data = dataHandle(listData[this.state.selectCity], this.state.selectCX, value[0]);
        //     localStorage.setItem("selectPP",value[0]);
        //     ops = {
        //         selectPP: value[0],
        //     }
        // }
        this.rData = genData(data);
        this.setState(
            {
                dataSource: new ListView.DataSource({
                    rowHasChanged: (row1, row2) => row1 !== row2,
                }),
            },
            () => {
                this.setState(
                    Object.assign(ops, {
                        show: false,
                        successType: false,
                        userName: "",
                        carTypes: "",
                        phoneNumber: "",
                        dataList: data,
                        dataSource: this.state.dataSource.cloneWithRows(
                            this.rData
                        ),
                    }),
                    () => {
                        if (value[0] === "其他" && this.state.urlOps.mobile) {
                            var dom = document.getElementById("phoneNumber");
                            dom.value = this.state.urlOps.mobile;
                            dom.disabled = true;
                        } else {
                            if (document.getElementById("phoneNumber")) {
                                var dom =
                                    document.getElementById("phoneNumber");
                                dom.value = "";
                                dom.disabled = false;
                            }
                        }
                    }
                );
            }
        );
    };

    selectClick = (type) => {
        console.log(type);
        this.setState({
            initData: this.state.selectData[type],
            selectType: type,
            show: !this.state.show,
        });
    };

    onMaskClick = () => {
        this.setState({
            show: false,
        });
    };

    carListHtml() {
        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: "#F5F5F9",
                    height: "1px",
                }}
            />
        );

        let index = 0;
        const row = (rowData, sectionID, rowID) => {
            let obj = {};
            if (index <= this.state.dataList.length - 1) {
                obj = this.state.dataList[index++];
            }
            return (
                <div
                    key={rowID}
                    style={{ padding: "0 12px" }}
                    onClick={() => {
                        const { urlOps } = this.state;
                        let url = "";
                        if (urlOps.mobile) {
                            // url = `/MarketingOnlineDetail?id=${obj.id}&city=${this.state.selectCity}&ZJ=${obj.ZJ}&mobile=${urlOps.mobile}`;
                            url = `/MarketingOnlineDetail?id=${obj.id}&city=${
                                this.state.selectCity
                            }&mobile=${urlOps.mobile}&back=${
                                urlOps.back || ""
                            }`;
                        } else {
                            // url = `/MarketingOnlineDetail?id=${obj.id}&city=${this.state.selectCity}&ZJ=${obj.ZJ}`;
                            url = `/MarketingOnlineDetail?id=${obj.id}&city=${
                                this.state.selectCity
                            }&back=${urlOps.back || ""}`;
                        }
                        if (urlOps.source) {
                            url = url + "&source=" + urlOps.source;
                        }
                        href(url);
                    }}
                >
                    <div
                        style={{
                            lineHeight: "50px",
                            color: "#888",
                            fontSize: 18,
                            borderBottom: "1px solid #F6F6F6",
                        }}
                    >
                        {obj.title}
                    </div>
                    <div style={{ display: "-webkit-box", padding: "8px 0" }}>
                        <div
                            style={{
                                width: "104px",
                                height: "104px",
                                marginRight: "12px",
                                background:
                                    "url(" + obj.miniImg + ") no-repeat 0 0",
                                backgroundSize: "cover",
                                borderRadius: "5px",
                            }}
                        >
                            {/* <div style={{ width: '88px', height: '88px', background: 'url('+mc+') no-repeat 0 0', backgroundSize: 'cover', borderRadius: '5px' }}></div> */}
                        </div>
                        <div
                            style={{
                                lineHeight: 1,
                                width: "calc(100% - 104px - 12px)",
                            }}
                        >
                            <div
                                style={{
                                    marginTop: "2px",
                                    marginBottom: "8px",
                                    fontWeight: "bold",
                                    fontSize: "15px",
                                }}
                            >
                                {obj.name}
                            </div>
                            <div style={{ marginTop: "8px" }}>
                                <div className="ZJ">
                                    <Badge
                                        text={obj.type}
                                        style={{
                                            padding: "0 3px",
                                            backgroundColor: "#fff",
                                            color: "#10C2B0",
                                            border: "1px solid #10C2B0",
                                            borderRadius: 2,
                                            fontWeight: 500,
                                        }}
                                    />
                                    {/* <Badge text={'全新车'} style={{ marginLeft: '8px', padding: '0 3px', backgroundColor: '#fff', color: '#F5A623',border: '1px solid #F5A623', borderRadius: 2, fontWeight: 500 }} /> */}
                                    {/* <Badge text={obj.newPattern ? '全新车' : '指导价'} style={{ marginRight: 6, marginTop: '-3px', padding: '2px 6px', backgroundColor: obj.newPattern ? '#F5A623' : '#FE3824', borderRadius: 3, fontWeight: 500, fontSize: '12px', height: '20px' }} />
                                        {obj.ZJ}<span>元/月</span> */}
                                    {/* <i className="del"><del>{obj.CKBJ}元/月</del></i> */}
                                </div>
                            </div>
                            <div style={{ marginTop: "16px" }}>
                                <div style={{ fontSize: 12, fontWeight: 500 }}>
                                    <div
                                        style={{
                                            marginTop: "5px",
                                            marginBottom: "6px",
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: "#999",
                                                marginRight: "8px",
                                            }}
                                        >
                                            续航
                                        </span>
                                        {obj.GKXH.join("/")}km
                                    </div>
                                </div>
                                <div style={{ fontSize: 12, fontWeight: 500 }}>
                                    <div
                                        style={{
                                            marginTop: "5px",
                                            marginBottom: "6px",
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: "#999",
                                                marginRight: "8px",
                                            }}
                                        >
                                            载方
                                        </span>
                                        {obj.ZDZF.length > 0
                                            ? obj.ZDZF.join("/") + "m³"
                                            : "-"}
                                    </div>
                                </div>
                            </div>
                            {/* <div style={{ display: 'flex', marginTop: '16px'}}>
                                    <div style={{ flex: 1, fontSize: 11, fontWeight: 500 }}>
                                        <div style={{ marginTop: '5px',marginBottom:'6px' }}>{obj.GKXH}km</div>
                                        <span style={{ color: '#999' }}>续航</span>
                                    </div>
                                    <div style={{ flex: 1, fontSize: 11, fontWeight: 500 }}>
                                        <div style={{ marginTop: '5px',marginBottom:'6px' }}>{obj.ZDZF}m³</div>
                                        <span style={{ color: '#999' }}>载方</span>
                                    </div>
                                    <div style={{ flex: 1, fontSize: 11, fontWeight: 500 }}>
                                        <div style={{ marginTop: '5px',marginBottom:'6px' }}>{obj.ZCRS}人</div>
                                        <span style={{ color: '#999' }}>准乘人数</span>
                                    </div>
                                </div> */}
                        </div>
                    </div>
                </div>
            );
        };
        return (
            <div>
                {/* banner */}
                {/* <div style={{ padding: '16px 12px' }}>
                        <img onClick={()=>{
                            href(`/MarketingOnlineActivity`);
                        }} style={{ width: '100%', borderRadius: '3px' }} src="https://image.tf56.com/dfs/group1/M00/4E/78/CiFCK1-GUKaAJyZhAABQELtGMcc798.png" />
                    </div> */}
                <ListView
                    dataSource={this.state.dataSource}
                    renderHeader={() => <span></span>}
                    renderFooter={() => (
                        <div
                            style={{
                                padding: 35,
                                textAlign: "center",
                                backgroundColor: "#f5f5f5",
                            }}
                        >
                            {this.state.dataList &&
                            this.state.dataList.length > 0
                                ? "更多车型，敬请期待！"
                                : "敬请期待！"}
                        </div>
                    )}
                    renderBodyComponent={() => <MyBody />}
                    renderRow={row}
                    renderSeparator={separator}
                    className="am-list"
                    pageSize={15}
                    useBodyScroll
                    // onScroll={() => { console.log('scroll'); }}
                    scrollRenderAheadDistance={500}
                    // onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                />
            </div>
        );
    }

    getSel() {
        const value = this.state.pickerValue;
        if (!value) {
            return "";
        }
        const treeChildren = arrayTreeFilter(
            cityData,
            (c, level) => c.value === value[level]
        );
        return treeChildren.map((v) => v.label).join(",");
    }

    huodongHtml() {
        return (
            <div style={{ textAlign: "center", padding: "0 35px" }}>
                {!this.state.successType ? (
                    <div>
                        <div>
                            <h3 style={{ fontSize: "16px", color: "#333" }}>
                                留下您的联系方式，我们将尽快与您联系
                            </h3>
                            {/* <p style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>目前业务已开通城市：杭州、合肥、成都、长沙、西安、深圳、武汉、郑州、义乌，其他城市尚未开通。</p> */}
                        </div>
                        <div style={{ marginTop: "30px" }}>
                            <label htmlFor="userName">
                                <input
                                    id="userName"
                                    placeholder="姓名"
                                    type="text"
                                    maxLength="10"
                                    style={{
                                        WebkitAppearance: "none",
                                        outline: "none",
                                        width: "100%",
                                        height: "42px",
                                        borderRadius: "5px",
                                        border: "1px solid #EBEBEB",
                                        padding: "0 11px",
                                    }}
                                />
                            </label>
                            <label
                                htmlFor="phoneNumber"
                                style={{ display: "block", marginTop: "16px" }}
                            >
                                <input
                                    id="phoneNumber"
                                    placeholder="手机号"
                                    type="tel"
                                    maxLength="11"
                                    style={{
                                        WebkitAppearance: "none",
                                        outline: "none",
                                        width: "100%",
                                        height: "42px",
                                        borderRadius: "5px",
                                        border: "1px solid #EBEBEB",
                                        padding: "0 11px",
                                    }}
                                />
                            </label>
                            <label
                                htmlFor="carType"
                                style={{
                                    display: "block",
                                    marginTop: "16px",
                                    position: "relative",
                                }}
                            >
                                <select
                                    id="carType"
                                    name="需求车型"
                                    style={{
                                        WebkitAppearance: "none",
                                        outline: "none",
                                        width: "100%",
                                        height: "42px",
                                        borderRadius: "5px",
                                        border: "1px solid #EBEBEB",
                                        padding: "0 11px",
                                    }}
                                >
                                    <option
                                        value=""
                                        disabled
                                        selected
                                        hidden
                                        style={{ display: "none" }}
                                    >
                                        需求车型
                                    </option>
                                    <option value="微面">微面</option>
                                    <option value="轻客">轻客</option>
                                    <option value="微卡">微卡</option>
                                    <option value="轻卡">轻卡</option>
                                </select>
                                <Icon
                                    type="down"
                                    size="sm"
                                    style={{
                                        position: "absolute",
                                        right: "5px",
                                        height: "42px",
                                    }}
                                />
                            </label>
                            <label
                                style={{
                                    display: "block",
                                    marginTop: "16px",
                                    position: "relative",
                                }}
                            >
                                <Picker
                                    extra="请选择城市"
                                    visible={this.state.visible}
                                    data={cityData}
                                    value={this.state.pickerValue}
                                    onChange={(v) =>
                                        this.setState({ pickerValue: v })
                                    }
                                    onOk={() =>
                                        this.setState({ visible: false })
                                    }
                                    onDismiss={() =>
                                        this.setState({ visible: false })
                                    }
                                >
                                    <List.Item
                                        extra={this.getSel()}
                                        onClick={() =>
                                            this.setState({ visible: true })
                                        }
                                    ></List.Item>
                                </Picker>
                            </label>
                            <Button
                                type="primary"
                                inline
                                style={{ width: "100%", marginTop: "25px" }}
                                onClick={() => {
                                    const url =
                                        "/gateway/huilianCust/hlThreadcs/addHlThread";
                                    // console.log(document.getElementById('userName').value)
                                    var userName =
                                        document.getElementById(
                                            "userName"
                                        ).value;
                                    var phoneNumber =
                                        document.getElementById(
                                            "phoneNumber"
                                        ).value;
                                    var carTypes =
                                        document.getElementById(
                                            "carType"
                                        ).value;
                                    console.log(this.state.pickerValue);
                                    if (!userName) {
                                        Toast.info("姓名不能为空!", 1);
                                        return;
                                    }
                                    if (!phoneNumber) {
                                        Toast.info("手机号不能为空!", 1);
                                        return;
                                    }
                                    if (
                                        phoneNumber[0] != 1 ||
                                        phoneNumber.length != 11
                                    ) {
                                        Toast.info("请输入正确的手机号!", 1);
                                        return;
                                    }
                                    if (!carTypes) {
                                        Toast.info("请选择车型!", 1);
                                        return;
                                    }
                                    if (this.state.pickerValue.length === 0) {
                                        Toast.info("请选择城市!", 1);
                                        return;
                                    }
                                    post({
                                        url,
                                        method: "GET",
                                        data: {
                                            companyName: userName,
                                            carTypes: carTypes,
                                            otherNeed: "",
                                            organizationName:
                                                this.state.selectCity,
                                            linkManName: userName,
                                            linkMobileNumber: phoneNumber,
                                            tierType: 4,
                                            resource: "客户预约",
                                            province: this.state.pickerValue[0],
                                            city: this.state.pickerValue[1],
                                            region: this.state.pickerValue[2],
                                        },
                                    }).then(
                                        (res) => {
                                            if (res.result === "success") {
                                                Toast.info("提交成功", 1);
                                                this.setState({
                                                    successType: true,
                                                    userName: userName,
                                                    carTypes: carTypes,
                                                    phoneNumber: phoneNumber,
                                                });
                                            } else {
                                                console.log(res);
                                                Toast.info(res.msg, 1);
                                            }
                                        },
                                        (res) => {
                                            console.log(res);
                                            Toast.info(res.msg, 1);
                                        }
                                    );
                                }}
                            >
                                提交
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div>
                            <Icon
                                type="check-circle"
                                color="#10C2B0"
                                style={{ width: "64px", height: "64px" }}
                            />
                            <h3
                                style={{
                                    fontSize: "20px",
                                    color: "#000",
                                    margin: "17px 0",
                                }}
                            >
                                提交成功
                            </h3>
                            <p style={{ fontSize: "14px", color: "#888" }}>
                                我们将尽快与您联系
                            </p>
                        </div>
                        <div
                            style={{
                                marginTop: "35px",
                                textAlign: "left",
                                padding: "0 50px",
                            }}
                        >
                            <p style={{ marginBottom: "15px" }}>
                                姓名：{this.state.userName}
                            </p>
                            <p style={{ marginBottom: "15px" }}>
                                手机号：{this.state.phoneNumber}
                            </p>
                            <p style={{}}>需求车型：{this.state.carTypes}</p>
                            <p style={{}}>
                                城市：{this.state.pickerValue.join(",")}
                            </p>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { initData, show, selectCX, selectPP, selectCity, selectType } =
            this.state;
        const menuEl = (
            <Menu
                className="single-foo-menu"
                data={initData}
                value={
                    selectType == 0
                        ? [selectCity]
                        : "" || selectType == 1
                        ? [selectCX]
                        : "" || selectType == 2
                        ? [selectPP]
                        : ""
                }
                level={1}
                onChange={this.onChange}
                height={document.documentElement.clientHeight * 0.6}
            />
        );
        const loadingEl = (
            <div
                style={{
                    position: "absolute",
                    width: "100%",
                    height: document.documentElement.clientHeight * 0.6,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <ActivityIndicator size="large" />
            </div>
        );
        const select = (
            <div
                style={{
                    display: "flex",
                    height: "45px",
                    fontSize: "16px",
                    color: "#1E283C",
                    alignItems: "center",
                    padding: "0 15px",
                    position: "relative",
                    zIndex: "90",
                    backgroundColor: "#fff",
                    textAlign: "center",
                }}
            >
                <div
                    style={{ flex: 1 }}
                    onClick={(e) => {
                        e.preventDefault(); // Fix event propagation on Android
                        this.selectClick(0);
                    }}
                >
                    <span style={{ marginRight: "5px" }}>
                        {selectCity ? selectCity : "省份"}
                    </span>
                    <Icon
                        type="down"
                        size="xs"
                        color="#E1E1E1"
                    />
                </div>
                {this.state.selectCity !== "其他" ? (
                    <div
                        style={{ flex: 1 }}
                        onClick={(e) => {
                            e.preventDefault(); // Fix event propagation on Android
                            this.selectClick(1);
                        }}
                    >
                        <span style={{ marginRight: "5px" }}>
                            {selectCX ? selectCX : "所有车型"}
                        </span>
                        <Icon
                            type="down"
                            size="xs"
                            color="#E1E1E1"
                        />
                    </div>
                ) : (
                    ""
                )}
                {/* {this.state.selectCity !== '其他' ? (<div style={{ flex: 1 }} onClick={(e)=>{
                    e.preventDefault(); // Fix event propagation on Android
                    this.selectClick(2);
                }}>
                    <span style={{ marginRight: '5px' }}>{ selectPP ? selectPP : '所有品牌' }</span>
                    <Icon type="down" size="xs" color="#E1E1E1" />
                </div>) : ''} */}
            </div>
        );
        return (
            <div className="marketingOnlineListBox">
                <div
                    className={show ? "single-menu-active" : ""}
                    style={{
                        position: "fixed",
                        top: 0,
                        zIndex: 80,
                        width: "100%",
                    }}
                >
                    {select}
                    {
                        // <div>
                        //     <NavBar
                        //         leftContent={<Icon type="down" size="xs" color="#E1E1E1" />}
                        //         mode="light"
                        //         icon={this.state.selectCity}
                        //         onLeftClick={this.handleClick}
                        //         className="single-top-nav-bar"
                        //     >
                        //     </NavBar>
                        // </div>
                    }
                    {show ? (initData ? menuEl : loadingEl) : null}
                    {show ? (
                        <div
                            className="menu-mask"
                            onClick={this.onMaskClick}
                        />
                    ) : null}
                </div>
                <div style={{ paddingTop: "0.45rem" }}>
                    {this.state.selectCity === "其他"
                        ? this.huodongHtml()
                        : this.carListHtml()}
                </div>
            </div>
        );
    }
}

export default MarketingOnlineIndex;



// WEBPACK FOOTER //
// ./src/marketingOnline/index/index.js